const MAX_ATTEMPTS = 50;
const INTERVAL_MS = 200;

let attempts = 0;
const intervalId = setInterval(() => {
  attempts += 1;

  const hosts = document.querySelectorAll('#frequently-bought-together-app-block');
  if (hosts.length === 0) {
    if (attempts >= MAX_ATTEMPTS) clearInterval(intervalId);
    return;
  }

  const allReady = Array.from(hosts).every((host) => {
    return (
      host.querySelector('.cbb-frequently-bought-selector-list li:first-child') &&
      host.querySelectorAll('.cbb-frequently-bought-product').length > 0 &&
      host.querySelector('.cbb-frequently-bought-form')
    );
  });
  if (!allReady) {
    if (attempts >= MAX_ATTEMPTS) clearInterval(intervalId);
    return;
  }

  hosts.forEach((host) => {
    const liTags = host.querySelectorAll('.cbb-frequently-bought-selector-list li');
    const liProductImages = host.querySelectorAll('.cbb-frequently-bought-products li .cbb-frequently-bought-product-image');
	const productCards = host.querySelectorAll('.cbb-frequently-bought-product');
	liTags.forEach((el, liIndex) => {
		const spans = Array.from(el.querySelectorAll(':scope > a, :scope > span'));
		const checkbox = el.querySelector('.cbb-frequently-bought-selector-input')
		const checkboxClone = checkbox.cloneNode(true);
		checkboxClone.addEventListener('click', (e) => {
			e.stopPropagation()
		})
		liProductImages[liIndex].appendChild(checkboxClone);
		checkbox.remove();
		const productImage = liProductImages[liIndex];
		if (!productImage || spans.length === 0) return;
		const spansWrapper = document.createElement('div');
		spans.forEach((span) => {
			const clone = span.cloneNode(true);
			spansWrapper.appendChild(clone);
			span.remove();
		});
		productImage.insertAdjacentElement('afterend', spansWrapper);
  	})

    const title = host.querySelector('.cbb-frequently-bought-title');
    const form = host.querySelector('.cbb-frequently-bought-form');
    if (title && form) {
      const titleClone = title.cloneNode(true);
      form.prepend(titleClone);
      title.remove();
    }
  });

  clearInterval(intervalId);
}, INTERVAL_MS);
